var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('h4',{staticClass:"mb-0"},[_vm._v("Olá, "+_vm._s(_vm.$store.state.user.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }